export default __webpack_public_path__ + "static/media/img_industry_2.34229ab3.png";